import React, { useContext,useState,useRef} from 'react';
import CsplLabel from '../../CsplControls/CsplLabel/CsplLabel';
import styles from './Preview.module.css';
import PersonalInfoView from './View/PersonalInfoView';
import {StylePropertiesEnum} from "../../../Enumeration/StylePropertiesEnum";
import { getApplicationDTO, getFirstHolderData , getIsKycProcessCompleted, getSecondHolderData } from '../../../Store/WidgetDataSelector';
import BankAccVerificationView from './View/BankAccVerification';
import NomineeView from './View/NomineeView';
import { useSelector } from "react-redux";
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import KycApplicationContext from '../../../Context/KYCApplicationContext/KYCApplicationContext';
import ReactTooltip from "react-tooltip";
import AlertModal from "../../CsplModal/AlertModal";
import { Accordion } from "react-bootstrap";
import '../../CsplControls/CsplAccordion/CsplAccordion.css';

function Preview(props) {
    const applicationContext = useContext(KycApplicationContext);
    const { t } = useTranslation("common");
    const firstHolderData = useSelector((state) =>
    getFirstHolderData (state)
    );
    const secHolderData = useSelector((state) =>
    getSecondHolderData (state)
    );
    const applicationDTO = useSelector((state) =>
     getApplicationDTO(state)
   );
    const disableForm = applicationContext.disableForm;
    let isKycProcessCompleted = useSelector((state) =>
    getIsKycProcessCompleted(state));
    const [isOpenAlertMsg,setIsOpenAlertMsg]=useState(false);
  
    
      // handle submit
function _handleCompleteKYC(event) {
    event.preventDefault();
    setIsOpenAlertMsg(true);
      
}
function kycProcessComfirmHandler(){
  props.onCompleteKYC(firstHolderData).then(
    (res) => {
      // operations to be dont on submit to avoid issues
      
    },
    (error) => {
      
    }
  );  
}

// tasks to be performed on clicking the back button
function _handleBack(event) {
  event.preventDefault();
  props.onBack();       
}

// tasks to be performed on clicking the next button
function _handleNext(event) {
    event.preventDefault();
    props.onNext();       
  }
//download Application Pdf
function downloadApplicationPdf(event) {
  event.preventDefault();
  if (props.ondownload && typeof (props.ondownload) === "function") {
    props.ondownload();
  }
  
}
 
  
    return (
      <div className="container">
         <Accordion className='gparentaccordion_style' alwaysOpen defaultActiveKey={[props.accordionkey]}>
        <div>
        {props.showDownload && <>
                 
                  <span className="downloadImg me-4 mb-3 padding-top-10" data-tip
                  data-for="downloadApplicationPdf"
                  onClick={downloadApplicationPdf}>
               </span>
               <span className='download_label'>{t("esign.downloadLabel")}</span>
               <ReactTooltip id="downloadApplicationPdf" place="left" effect="solid" className="customeTheme">
              {/*   Download the application */}
                {t("esign.downloadTheApplication")}
               </ReactTooltip>
                </>} 
          {/* First Holder */}
        <Accordion.Item eventKey="0" className='mb-3'>
            <div className={props.isPreview ? styles.firstHolder : ''} >
                <Accordion.Header >
                <span className='w-100' ><CsplLabel label={"title.FirstHolder"}></CsplLabel></span>
              
                </Accordion.Header>
                      
            </div>
          
            <Accordion.Body>
              <div className='ps-4 pe-0 mb-3 dotted_line'>
            <PersonalInfoView data={firstHolderData}/>
            <NomineeView data={firstHolderData}/>
            <BankAccVerificationView data={firstHolderData}  />
            </div>
            </Accordion.Body>

            </Accordion.Item>

             {/* Second Holder */}
            <Accordion.Item eventKey="1" className='mb-4'>

            {secHolderData && applicationDTO && applicationDTO.kycAccountTypeShortName==='JA' && <>
            <Accordion.Header > 
           
              <span className="w-100" ><CsplLabel label={"title.SecondHolder"}></CsplLabel></span>
               
              </Accordion.Header>
            
              </>}

              <Accordion.Body>
              <div className='ps-4 pe-0 mb-3 dotted_line'>
            <PersonalInfoView data={secHolderData} show/>
               </div>
             </Accordion.Body>
            </Accordion.Item>

        </div>
        {props.isPreview && <><br/><br/></>}
        </Accordion>

        <div className="action_bar d-flex justify-content-between py-2">
              <div>
                {(
                  <Button
                    className="btn shadow-none action_btn"
                    onClick={event=>_handleBack(event)}>
                    {t("form.back")}
                  </Button>
                )}
              </div>
              <div>
               { disableForm &&  <Button
                  className="btn shadow-none action_btn me-2"
                  onClick={event=>_handleNext(event)}
                  type="submit">{t("form.next")}
                </Button> 
                }

                { !disableForm && <Button
                  className="btn shadow-none action_btn me-2"
                  onClick={event=>_handleCompleteKYC(event)}
                  type="submit" disabled={!isKycProcessCompleted}>{t("form.completeKYC")}     
                </Button> 
                }     

                 {isOpenAlertMsg &&
                <AlertModal
                isModalOpen={isOpenAlertMsg}
                setIsModalOpen={setIsOpenAlertMsg}
                businessProcess={kycProcessComfirmHandler} 
                modalWidth={StylePropertiesEnum.sm}
                type={StylePropertiesEnum.OKCANCEL}
                title={"modal.alertModalTitle"}
              >
                {t("message.kycCompleteAlert")}
              </AlertModal>
                }      
              </div>
            </div>
          </div>
    )
}

export default Preview;
